export default {
  SET_USER: 'SET_USER',
  UPDATE_USER: 'UPDATE_USER',
  SET_USER_BALANCE: 'SET_USER_BALANCE',
};
